import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import CheckoutReviewCustomState from "@tKgpco/Store/Data/CheckoutReviewAndSubmit/CheckoutReviewState";
import { Draft } from "immer";

const initialState: CheckoutReviewCustomState = {};

const reducer = {
    "Custom/CheckoutReview/SetSpecialDeliveryInstruction": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { instructionsArray: string[] },
    ) => {
        const instructionArrayPipeSeparated = action.instructionsArray.join("|");
        draft.SpecialDeliveryInstructionList = instructionArrayPipeSeparated;
    },
    "Custom/CheckoutReviewAndSubmit/SetAccountNumber": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { accountNumber: any },
    ) => {
        draft.accountNumber = action.accountNumber;
    },
    "Custom/CheckoutReview/OrderApprovalNotes": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { approvalNotes: string },
    ) => {
        draft.approvalNotes = action.approvalNotes;
    },

    "Custom/CheckoutReview/ReleaseNumber": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { releaseNumber: string },
    ) => {
        draft.releaseNumber = action.releaseNumber;
    },
    "Custom/CheckoutReview/SetPackingListNotesAndInstruction": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { packingAndInstructions: string[] },
    ) => {
        const packingAndInstructionPipeSeparated = action.packingAndInstructions.join("|");
        draft.packingListNotesList = packingAndInstructionPipeSeparated;
    },
    "Custom/CheckoutReview/WorkOrder": (draft: Draft<CheckoutReviewCustomState>, action: { workOrder: string }) => {
        draft.workOrder = action.workOrder;
    },
    "Custom/CheckoutReview/WorkOrderError": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { workOrderError: string },
    ) => {
        draft.workOrderError = action.workOrderError;
    },
    "Custom/CheckoutReview/CustomerReference1": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { customerReference1: string },
    ) => {
        draft.customerReference1 = action.customerReference1;
    },
    "Custom/CheckoutReview/CustomerReference1Error": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { customerReference1Error: string },
    ) => {
        draft.customerReference1Error = action.customerReference1Error;
    },

    "Custom/CheckoutReview/CustomerReference2": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { customerReference2: string },
    ) => {
        draft.customerReference2 = action.customerReference2;
    },
    "Custom/CheckoutReview/CustomerReference2Error": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { customerReference2Error: string },
    ) => {
        draft.customerReference2Error = action.customerReference2Error;
    },

    "Custom/CheckoutReview/CustomerReference3": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { customerReference3: string },
    ) => {
        draft.customerReference3 = action.customerReference3;
    },
    "Custom/CheckoutReview/CustomerReference3Error": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { customerReference3Error: string },
    ) => {
        draft.customerReference3Error = action.customerReference3Error;
    },

    "Custom/CheckoutReview/CustomerReference4": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { customerReference4: string },
    ) => {
        draft.customerReference4 = action.customerReference4;
    },
    "Custom/CheckoutReview/CustomerReference4Error": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { customerReference4Error: string },
    ) => {
        draft.customerReference4Error = action.customerReference4Error;
    },
    "Custom/CheckoutReview/PoNumber": (draft: Draft<CheckoutReviewCustomState>, action: { poNumber: string }) => {
        draft.poNumber = action.poNumber;
    },

    "Custom/CheckoutReview/ExpeditedUserName": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { expeditedUserName: string },
    ) => {
        draft.expeditedUserName = action.expeditedUserName;
    },
    "Custom/CheckoutReview/ExpeditedUserNameError": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { expeditedUserNameError: string },
    ) => {
        draft.expeditedUserNameError = action.expeditedUserNameError;
    },

    "Custom/CheckoutReview/ExpeditedUserPhone": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { expeditedUserphone: string },
    ) => {
        draft.expeditedUserphone = action.expeditedUserphone;
    },
    "Custom/CheckoutReview/ExpeditedUserPhoneError": (
        draft: Draft<CheckoutReviewCustomState>,
        action: { expeditedUserPhoneError: string },
    ) => {
        draft.expeditedUserPhoneError = action.expeditedUserPhoneError;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
